module.exports = __webpack_public_path__ + "media/images/redesign-images/promotions/promos-07-70be6830c8ad31963fdf7ba012cb8ab3.jpg";